export var buildFilters = function buildFilters(banner) {
  var _banner$category, _banner$subCategory, _banner$brand;
  var filters = [];
  if ((_banner$category = banner.category) == null ? void 0 : _banner$category.id) {
    filters.push("category---".concat(banner.category.id));
  }
  if ((_banner$subCategory = banner.subCategory) == null ? void 0 : _banner$subCategory.id) {
    filters.push("subcategory---".concat(banner.subCategory.id));
  }
  if ((_banner$brand = banner.brand) == null ? void 0 : _banner$brand.slug) {
    filters.push("brand---".concat(banner.brand.slug));
  }
  return encodeURIComponent(filters.join('+'));
};
export var buildSearchUrl = function buildSearchUrl(sellerId, banner, baseUrl) {
  var filters = buildFilters(banner);
  return "".concat(baseUrl, "/busca/?filters=seller---").concat(sellerId, "&").concat(filters);
};